module.exports = __webpack_public_path__ + "img/yuanwei.10b4bf6f.png";